import { useSpotsChartsDataContext } from "./hooks/useSpotsChartsDataContext";
import { SpotsMap } from "../../../Common/Charts/SpotsMap";

const SPOTS_CONFIG = {
    popupFields: {
        title: "natureza_apurada",
        local: "desc_subtipolocal",
        bairro: "bairro",
        logradouro: "logradouro",
    },
    filters: [
        { key: "natureza_apurada", label: "Filtrar por Natureza", type: "select" },
        { key: "bairro", label: "Filtrar por Bairro", type: "select", allLabel: "Todos" },
    ],
    details: {
        title: "natureza_apurada",
        bairro: "bairro",
        localType: "desc_subtipolocal",
        period: { month: "mes_estatistica", year: "ano_estatistica" },
    },
    stats: [
        { label: "Total de ocorrências", type: "count" },
        { label: "Naturezas únicas", field: "natureza_apurada", type: "unique" },
        { label: "Bairros afetados", field: "bairro", type: "unique" },
        { label: "Períodos", type: "period", monthField: "mes_estatistica", yearField: "ano_estatistica" },
    ],
};

export function Spots() {
    const { chartData } = useSpotsChartsDataContext();

    return <SpotsMap spots={chartData?.spots || []} config={SPOTS_CONFIG} />;
}